import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime, filter, Subject } from 'rxjs';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { ConfigurationService } from 'src/app/services/core/configuration/configuration.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { sweetAlert } from 'src/app/utils/swal';
@UntilDestroy()
@Component({
  selector: 'app-vehicles',
  templateUrl: './vehicles.component.html',
  styleUrls: ['./vehicles.component.css']
})
export class VehiclesComponent implements OnInit {
  selectedStatus = '';
  filteredVehicles:any;
  vehicleModalObj:any;
  search:any;
  vehicles = [];
  companyId: any;
  user:any;
  currentPage: number = 1;
  totalPages = 0;
  totalResults = 0;
  numberOfRecords = NUMBER_OF_RECORDS;
  spaceTypes:any;
  prespaceTypes:any;
  status:boolean = true;
  loading: any = null;
  private readonly searchSubject = new Subject<string | undefined>();

  constructor(private cedentialService: CredentialService,
    private sharedDataService: SharedDataService,
    private configurationService: ConfigurationService,
    private spaceTypeService: SpaceTypeService
  ) { }

  ngOnInit(){
    this.getUser();
    this.getSpaceTypes()
    this.initializeSearch();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(untilDestroyed(this))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.companyId = this.user.company.id
          this.getCompanyWiseVehicles(this.currentPage);

        }
      });
  }

  getCompanyWiseVehicles(page: number) {
    let queryParams: any = {
      limit: this.numberOfRecords,
      page,
      isActive: this.status
    }
    if (this.search) {
      queryParams['search'] = this.search;
    }

    this.cedentialService.getVehicles(this.companyId, queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.vehicles = data.results
        this.filteredVehicles = [...this.vehicles];
        this.totalPages = data.totalPages;
        this.totalResults = data.totalResults;
      }
    })

  }

  // filterLosList() {
  //   if (this.selectedStatus) {
  //     this.filteredVehicles = this.vehicles.filter((item: any) =>
  //       item.isActive === (this.selectedStatus === 'Active')
  //     );
  //   } else {
  //     this.filteredVehicles = [...this.vehicles];
  //   }
  // }

  openDriverModal(vehicle: any) {
    this.vehicleModalObj = vehicle;
  }

  getSpaceTypes() {
    this.spaceTypeService.getPicker({ isActive: true, limit: 9999 }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.spaceTypes = data.results;
        this.prespaceTypes = this.spaceTypes.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

  // onSearch(query: any) {
  //   if (query) {
  //     this.searchSubject.next(query);
  //   } else {
  //     this.currentPage = 1;
  //     this.getCompanyWiseVehicles(this.currentPage);
  //   }
  // }

  onSearchInput() {
    this.searchSubject.next(this.search);
  }

  // listenSearch() {
  //   this.searchSubject
  //     .pipe(debounceTime(500), untilDestroyed(this))
  //     .subscribe((search) => {
  //       this.currentPage = 1;
  //       this.vehicles= [];
  //       this.getCompanyWiseVehicles(this.currentPage, search);
  //     });
  // }

  initializeSearch() {
    this.searchSubject
      .pipe(
        debounceTime(500), // wait for typing to stop
        filter((search: any) => !search || search.length >= 3)  // only trigger if >=3 chars OR empty (to reset search)
      ).subscribe(() => {
        this.currentPage = 1;
        this.getCompanyWiseVehicles(this.currentPage)
      });
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getCompanyWiseVehicles(page);
  }

  onSelectStatus(){
   this.getCompanyWiseVehicles(this.currentPage = 1)
  }
  onSyncVehivle(vehiclesId: string) {
    this.loading = vehiclesId;
    this.cedentialService.syncData(vehiclesId, 'vehicles')
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          sweetAlert('Success', 'Vehicle Synced Successfully!', 'success', 'OK');
          this.getCompanyWiseVehicles(this.currentPage);
        },
        error: (err) => {
          sweetAlert('Error', err?.error?.message, 'error', 'OK');
          this.loading = null;
        },
        complete: () => {
          this.loading = null;
        }
      });
  }

}


